import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetDocIdsByQueryKey = (matterId: string | undefined, queryKey: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<{ docIds: string[] }>(
    [QueryEntity.SubsetDocIds, { matterId, queryKey }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/doc-ids-by-key/${queryKey}`,
        fetchConfigGET,
      );
      if (!res.ok) {
        throw new Error('Failed to fetch doc IDs by query key');
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!queryKey,
      staleTime: Infinity,
    },
  );
};
